import { FuelIcon, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { DS_TOKENS } from 'constants/styled.contants';
import React from 'react';

const AccessRequestSent: React.FC<{ iSmallProfile: boolean }> = ({ iSmallProfile }) => (
  <FuelFlex
    defaultProps={{
      flexDirection: 'column',
      height: iSmallProfile ? '100%' : 'calc(100% - 250px)',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <FuelIcon size="giant" name="one-check" iconStyle="outlined" />
    <FuelTypography weight="bold" size="body-lg" color="neutral-strong" spacingTop={parseFloat(DS_TOKENS.spacing.km4)}>
      Solicitação recebida!
    </FuelTypography>
    <FuelTypography weight="medium" size="body-md" color="neutral-default">
      Nós entraremos em contato com você
    </FuelTypography>
  </FuelFlex>
);

export default AccessRequestSent;
